export function getInputAttributeDataTypes() {
  return [
    'boolean',
    'date',
    'decimal',
    'integer',
    'string',
    'timestamp',
  ].sort();
}
